import React from "react";
import { AiFillGithub, AiFillLinkedin } from "react-icons/ai";
import { BsInstagram } from "react-icons/bs";
import { ReactComponent as UK } from ".././svg/uk.svg";
import { ReactComponent as USA } from ".././svg/usa.svg";

export const Footer = () => {
  return (
    <div className="Footer">
      <div className="Icons">
        <a href="https://github.com/serge-21" target="blank">
          <AiFillGithub className="Footer-icon" />
        </a>
        <span />
        <a href="https://www.linkedin.com/in/serge-0860aa150/" target="blank">
          <AiFillLinkedin className="Footer-icon" />
        </a>
        <span />

        <a href="https://www.instagram.com/serge_alkhalil/" target="blank">
          <BsInstagram className="Footer-icon" />
        </a>
      </div>

      <div className="copyright-section">
        <p> &copy; 2023 Serge Alkhalil | All rights reserved </p>
        <div className="flags">
          <UK className="flag" />
          <USA className="flag" />
        </div>
      </div>
    </div>
  );
};
